/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { UserRoles } from 'app/constants/roles.constants';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'firms',
    title: 'Firmalar',
    type: 'basic',
    icon: 'heroicons_outline:building-storefront',
    link: '/admin/firmalar',
  },
  {
    id: 'errorTypes',
    title: 'Hata Türleri',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-triangle',
    link: '/admin/hata-turleri',
    visibleOnlyTo: [UserRoles.admin],
  },
  {
    id: 'errorElements',
    title: 'Hata Elemanları',
    type: 'basic',
    icon: 'heroicons_outline:cube-transparent',
    link: '/admin/hata-elemanlari',
    visibleOnlyTo: [UserRoles.admin],
  },
  {
    id: 'errorLevels',
    title: 'Hata Seviyeleri',
    type: 'basic',
    icon: 'heroicons_outline:scale',
    link: '/admin/hata-seviyeleri',
    visibleOnlyTo: [UserRoles.admin],
  },
  {
    id: 'standarts',
    title: 'Standartlar',
    type: 'basic',
    icon: 'heroicons_outline:document',
    link: '/admin/standartlar',
  },
  {
    id: 'users',
    title: 'Kullanıcılar',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/admin/kullanicilar',
  },
  {
    id: 'ticket',
    title: 'Görevler',
    type: 'basic',
    icon: 'heroicons_outline:sparkles',
    link: '/admin/gorevler',
  },
  {
    id: 'reports',
    title: 'Raporlar',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/admin/raporlar/liste',
  },
  {
    id: 'reports-templates',
    title: 'Rapor Şablonları',
    type: 'basic',
    icon: 'heroicons_outline:newspaper',
    link: '/admin/raporlar/sablonlar',
    visibleOnlyTo: [UserRoles.admin],
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'firms',
    title: 'Firmalar',
    type: 'basic',
    icon: 'heroicons_outline:building-storefront',
    link: '/admin/firmalar',
  },
  {
    id: 'errorTypes',
    title: 'Hata Türleri',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-triangle',
    link: '/admin/hata-turleri',
  },
  {
    id: 'errorElements',
    title: 'Hata Elemanları',
    type: 'basic',
    icon: 'heroicons_outline:cube-transparent',
    link: '/admin/hata-elemanlari',
  },
  {
    id: 'errorLevels',
    title: 'Hata Seviyeleri',
    type: 'basic',
    icon: 'heroicons_outline:scale',
    link: '/admin/hata-seviyeleri',
  },
  {
    id: 'standarts',
    title: 'Standartlar',
    type: 'basic',
    icon: 'heroicons_outline:document',
    link: '/admin/standartlar',
  },
  {
    id: 'users',
    title: 'Kullanıcılar',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/admin/kullanicilar',
  },
  {
    id: 'ticket',
    title: 'Görevler',
    type: 'basic',
    icon: 'heroicons_outline:sparkles',
    link: '/admin/gorevler',
  },
  {
    id: 'reports',
    title: 'Raporlar',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/admin/raporlar/liste',
  },
  {
    id: 'reports-templates',
    title: 'Rapor Şablonları',
    type: 'basic',
    icon: 'heroicons_outline:newspaper',
    link: '/admin/raporlar/sablonlar',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'firms',
    title: 'Firmalar',
    type: 'basic',
    icon: 'heroicons_outline:building-storefront',
    link: '/admin/firmalar',
  },
  {
    id: 'errorTypes',
    title: 'Hata Türleri',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-triangle',
    link: '/admin/hata-turleri',
  },
  {
    id: 'errorElements',
    title: 'Hata Elemanları',
    type: 'basic',
    icon: 'heroicons_outline:cube-transparent',
    link: '/admin/hata-elemanlari',
  },
  {
    id: 'errorLevels',
    title: 'Hata Seviyeleri',
    type: 'basic',
    icon: 'heroicons_outline:scale',
    link: '/admin/hata-seviyeleri',
  },
  {
    id: 'standarts',
    title: 'Standartlar',
    type: 'basic',
    icon: 'heroicons_outline:document',
    link: '/admin/standartlar',
  },
  {
    id: 'users',
    title: 'Kullanıcılar',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/admin/kullanicilar',
  },
  {
    id: 'ticket',
    title: 'Görevler',
    type: 'basic',
    icon: 'heroicons_outline:sparkles',
    link: '/admin/gorevler',
  },
  {
    id: 'reports',
    title: 'Raporlar',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/admin/raporlar/liste',
  },
  {
    id: 'reports-templates',
    title: 'Rapor Şablonları',
    type: 'basic',
    icon: 'heroicons_outline:newspaper',
    link: '/admin/raporlar/sablonlar',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'firms',
    title: 'Firmalar',
    type: 'basic',
    icon: 'heroicons_outline:building-storefront',
    link: '/admin/firmalar',
  },
  {
    id: 'errorTypes',
    title: 'Hata Türleri',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-triangle',
    link: '/admin/hata-turleri',
  },
  {
    id: 'errorElements',
    title: 'Hata Elemanları',
    type: 'basic',
    icon: 'heroicons_outline:cube-transparent',
    link: '/admin/hata-elemanlari',
  },
  {
    id: 'errorLevels',
    title: 'Hata Seviyeleri',
    type: 'basic',
    icon: 'heroicons_outline:scale',
    link: '/admin/hata-seviyeleri',
  },
  {
    id: 'standarts',
    title: 'Standartlar',
    type: 'basic',
    icon: 'heroicons_outline:document',
    link: '/admin/standartlar',
  },
  {
    id: 'users',
    title: 'Kullanıcılar',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/admin/kullanicilar',
  },
  {
    id: 'ticket',
    title: 'Görevler',
    type: 'basic',
    icon: 'heroicons_outline:sparkles',
    link: '/admin/gorevler',
  },
  {
    id: 'reports',
    title: 'Raporlar',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/admin/raporlar/liste',
  },
  {
    id: 'reports-templates',
    title: 'Rapor Şablonları',
    type: 'basic',
    icon: 'heroicons_outline:newspaper',
    link: '/admin/raporlar/sablonlar',
  },
];
